import Vue from 'vue'
import Router from 'vue-router'
//引用模板
import HelloWorld from '@/components/HelloWorld'
import login from '@/components/login'
import home from '@/components/home'
import long_range_control from '@/components/long_range_control'
import device from '@/components/device'
import map from '@/components/map'
import organ from '@/components/organ'
import setMiniApp from '@/components/setMiniApp'
import user from '@/components/user'
import whiteList from '@/components/whiteList'
import device_link_cord from '@/components/device_link_cord'
import get_qr_code from '@/components/get_qr_code'
import assignPower from '@/components/assignPower'
import create_qr_codePower from '@/components/create_qr_codePower'
import producter from '@/components/producter'
import device_reperdory from '@/components/device_reperdory'
import device_area from '@/components/device_area'


Vue.use(Router)
export default new Router({
  routes: [
    {
      path: '/login',
      name: 'login',
    	hidden: true,//是否选项卡
      component: login
    },
    {
    	path: '/',
      name: '设备管理',
      component: home,
      iconCls: 'el-icon-tickets',
      children : [
      	{path:'/device',name:'设备查询',component:device,iconCls: 'el-icon-tickets',},
      	{path:'/getDevice_link_cord',name:'连接记录',component:device_link_cord,iconCls: 'el-icon-mobile-phone',},
      	{path:'/long_range_control',name:'远程控制',component:long_range_control,iconCls: 'el-icon-mobile-phone',},
      	{path:'/get_qr_code',name:'二维码获取',component:get_qr_code,iconCls: 'el-icon-mobile-phone',isAdmin:true},
      	{path:'/device_reperdory',name:'设备库存表',component:device_reperdory,iconCls: 'el-icon-mobile-phone',},
      	{path:'/device_area',name:'区域差异查询',component:device_area,iconCls: 'el-icon-mobile-phone',},
      ]
    },
    {
    	path: '/',
      name: '用户管理',
      component: home,
      iconCls: 'el-icon-tickets',
      children : [
      	{path:'/user',name:'用户查询',component:user,iconCls: 'el-icon-tickets',},
      	{path:'/whiteList',name:'白名单查询',component:whiteList,iconCls: 'el-icon-mobile-phone',},
      	{path:'/assignPower',name:'分配区域权限',component:assignPower,iconCls: 'el-icon-mobile-phone',},
      	{path:'/create_qr_codePower',name:'创建设备二维码权限',component:create_qr_codePower,iconCls: 'el-icon-mobile-phone',isAdmin:true},
        {path:'/producter',name:'生产测试用户',component:producter,iconCls: 'el-icon-mobile-phone',isAdmin:true},
      ]
    },
    {
    	path: '/organ',
      name: '机构管理',
      component: home,
      leaf: true,//是否选项卡
      iconCls: 'el-icon-news',
      children: [
	        { path: '/organ', component: organ, name: '机构查询',iconCls: 'el-icon-picture', },
	    ]
    },
    {
    	path: '/setMiniApp',
      name: '小程序配置',
      component: home,
      leaf: true,//是否选项卡
      iconCls: 'el-icon-setting',
      children: [
	        { path: '/setMiniApp', component: setMiniApp, name: '小程序配置',iconCls: 'el-icon-s-operation', },
	    ]
    },
    {
        path: '/map',
        component: home,
        name: '地图展示',
        iconCls: 'el-icon-picture',
        leaf: true,//是否选项卡
        children: [
            { path: '/map', component: map, name: '分布地图',iconCls: 'el-icon-picture', }
        ]
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js